import { ContentDiv, TitleDiv, RowDiv, StyledSpan } from "../styles";

interface IProps {
  onGoTo(destination: string): void;
}
export function ProjectStep({ onGoTo }: IProps) {
  return (
    <>
      <ContentDiv>
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <span style={{ color: "#222222", fontWeight: 600 }}>
            Usuários da Célula (10)
          </span>
          {/* <StyledSpan onClick={()=> {onGoTo('users')}} >Ir para Usuários</StyledSpan> */}

          <span style={{ color: "#222222", fontSize: 14 }}>
            José Alcântara (Coordenador), Maria Alcântara (Atendimento), e mais
            8.
          </span>
        </div>
      </ContentDiv>
      <br />
      <ContentDiv>
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <span style={{ color: "#222222", fontWeight: 600 }}>
            Clientes (0)
          </span>
          {/* <StyledSpan onClick={()=> {onGoTo('users')}} >Ir para Usuários</StyledSpan> */}

          <span style={{ color: "#222222", fontSize: 14 }}>
            Nenhum cliente.
          </span>
        </div>
      </ContentDiv>
      <br />
      <ContentDiv>
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <span style={{ color: "#222222", fontWeight: 600 }}>
            Projetos (0)
          </span>
          {/* <StyledSpan onClick={()=> {onGoTo('users')}} >Ir para Usuários</StyledSpan> */}

          <span style={{ color: "#222222", fontSize: 14 }}>
            Nenhum projeto.
          </span>
        </div>
      </ContentDiv>
    </>
  );
}
